module.exports = __webpack_public_path__ + "img/chanpin.d14eaac3.png";